(function() {
  const onReady = (fn) => {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(fn, 0);
    } else {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    }
  };

  onReady(function() {
    // 查找文章容器（Dawn 13 默认结构）
    const articleRoot = document.querySelector('.article-template__content');
    if (!articleRoot) return;

    const wrapper = articleRoot.querySelector('.tam-article-grid');
    const content = articleRoot.querySelector('.tam-article__main');
    const tocList = articleRoot.querySelector('#tam-toc-list');
    if (!wrapper || !content || !tocList) return;

    // 收集标题（只取正文内 h2/h3；正文 H1 是模板/编辑器误用，不进 TOC）
    const headings = Array.from(content.querySelectorAll('h2, h3')).filter(h => h.textContent.trim().length > 0);
    // W7-1：H2 ≥ 2 才显（短文章无 TOC 价值，避免一列空荡）
    if (headings.length < 2) {
      const toc = articleRoot.querySelector('.tam-toc');
      if (toc) toc.style.display = 'none';
      return;
    }

    // 生成唯一 ID
    const slugCounts = {};
    const slugify = (text) => {
      let slug = text.toLowerCase().trim()
        .replace(/[\s\.\,\/\?\!\:\;\(\)\[\]'"“”‘’&]+/g, '-')
        .replace(/[^a-z0-9\-]+/g, '')
        .replace(/\-+/g, '-')
        .replace(/^\-|\-$/g, '');
      if (!slug) slug = 'section';
      if (slugCounts[slug] != null) slug = slug + '-' + (++slugCounts[slug]);
      else slugCounts[slug] = 0;
      return slug;
    };

    headings.forEach(h => { if (!h.id) h.id = slugify(h.textContent); });

    // 构建两级目录
    let currentUL = tocList;
    let lastLevel = 2;
    headings.forEach(h => {
      const level = parseInt(h.tagName.slice(1), 10); // 2 或 3
      if (level > lastLevel) {
        const li = currentUL.lastElementChild;
        if (li) {
          const sub = document.createElement('ul');
          sub.className = 'tam-toc__sub';
          li.appendChild(sub);
          currentUL = sub;
        }
      } else if (level < lastLevel) {
        currentUL = currentUL.parentElement.closest('ul') || tocList;
      }
      lastLevel = level;

      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = h.textContent.trim();
      a.dataset.targetId = h.id;
      a.addEventListener('click', (e) => {
        e.preventDefault();
        const target = content.querySelector('#' + a.dataset.targetId);
        if (!target) return;
        // 计算顶部偏移，避免被 Dawn 顶栏遮挡
        const header = document.querySelector('sticky-header, .header-wrapper, header');
        const headerH = header ? header.offsetHeight : 0;
        const y = target.getBoundingClientRect().top + window.pageYOffset - headerH - 12;
        window.scrollTo({ top: y, behavior: 'smooth' });
        history.replaceState(null, '', '#' + a.dataset.targetId);
      });
      li.appendChild(a);
      currentUL.appendChild(li);
    });

    // 高亮当前目录项
    const links = Array.from(tocList.querySelectorAll('a'));
    const setActive = (id) => {
      links.forEach(a => a.classList.toggle('is-active', a.dataset.targetId === id));
    };

    const io = new IntersectionObserver((entries) => {
      // 选取最靠上的可见标题
      const visible = entries.filter(e => e.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible[0]) setActive(visible[0].target.id);
    }, {
      root: null,
      // 提前在视口 30% 处触发，滚到新段落会更早高亮
      rootMargin: '0px 0px -70% 0px',
      threshold: 0
    });

    headings.forEach(h => io.observe(h));

    // 初始带锚点进入页时
    if (location.hash) setActive(location.hash.replace('#', ''));
  });
})();

